import React, { useState } from 'react';
import {
  PayPalButtons,
  usePayPalScriptReducer,
  FUNDING,
} from '@paypal/react-paypal-js';
import type { FUNDING_SOURCE } from '@paypal/paypal-js';
import FormErrorLabel from '../../input/FormErrorLabel';
import { PayPalButtonMethods } from '../../../types/PayPal';

export type PayPalCheckoutButtonProps = {
  buttonMethods: PayPalButtonMethods;
  buttonType?: 'PAYPAL' | 'PAYLATER' | 'VENMO';
};

const PayPalCheckoutButton: React.FC<PayPalCheckoutButtonProps> = ({
  buttonMethods: { createOrder, onApprove, onCancel, onError, onClick },
  buttonType,
}: PayPalCheckoutButtonProps) => {
  const [{ isPending }] = usePayPalScriptReducer();
  const [formErrors, setFormErrors] = useState<string[]>([]);
  let fundingSource: FUNDING_SOURCE | undefined;
  let color: 'gold' | 'blue' | undefined;

  switch (buttonType) {
    case 'PAYPAL':
      fundingSource = FUNDING.PAYPAL;
      color = 'gold';
      break;
    case 'PAYLATER':
      fundingSource = FUNDING.PAYLATER;
      color = 'gold';
      break;
    case 'VENMO':
      fundingSource = FUNDING.VENMO;
      color = 'blue';
      break;
    default:
  }
  const tryCreateOrder = async (): Promise<string> => {
    setFormErrors([]);
    try {
      const token = await createOrder();
      return token;
    } catch (error) {
      // TODO: friction logging can be added here to discover true error
      // eslint-disable-next-line no-console
      console.error(error);
    }
    return '';
  };

  // TODO: Remove the any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleOnError = (error: any): void => {
    setFormErrors([
      'Unable to create PayPal transaction',
      'Please try a different payment method',
    ]);
    onError?.(error);
  };
  return (
    <div style={{ width: '100%', maxWidth: '250px' }}>
      {isPending ? null : (
        <PayPalButtons
          className="flex flex-col"
          style={{
            height: 45,
            tagline: false,
            color,
          }}
          createOrder={tryCreateOrder}
          onApprove={onApprove}
          onCancel={onCancel}
          onError={handleOnError}
          onClick={onClick}
          fundingSource={fundingSource}
        />
      )}
      <FormErrorLabel errors={formErrors} lessPadding />
    </div>
  );
};

export default PayPalCheckoutButton;
